export default __webpack_public_path__ + "static/media/people7full.b7963c84.jpg";